<script>
import { Inertia } from '@inertiajs/inertia'
import Edit from './edit.vue'

export default {
  extends: Edit,

  data() {
    return {
      ...Edit.data.call(this),
      title: 'Vehicles :: Add Vehicle',
    }
  },

  methods: {
    submit() {
      Inertia.post(this.$route('vehicles.store'), this.getFormData(), {
        preserveState: true,
        onFinish: () => {
          this.$refs.topAnchor.scrollIntoView()
        }
      })
    },
  },
}
</script>
